module.exports = __webpack_public_path__ + "img/disco_result.fab0a044.png";